export { default as ContactDepartmentEditTemplate } from './ContactDepartmentEdit';
export { default as ContactDepartmentListTemplate } from './ContactDepartmentList';